import { TreeMapDownloadDataButton } from './TreeMapDownloadDataButton.js';
import { useBehavioralTrackingProps as _useBehavioralTrackingProps } from '../../../../core/hooks/useBehavioralTrackingProps.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { A11yToolbarTabIndex } from '../../../core/types/toolbar.js';
import { DEFAULT_TOOLBAR_PLACEMENT } from '../../constants.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useTreeMapRawData } from '../../context/TreeMapRawDataContext.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const TreeMapToolbar = () => {
  const toolbarConfig = useToolbarConfig();
  const dispatch = useTooltipReducer();
  const toolbarPlacement =
    toolbarConfig?.placement ?? DEFAULT_TOOLBAR_PLACEMENT;

  const handleMouseEnter = () => {
    dispatch({ type: 'RESET_TOOLTIP' })();
  };

  const isDownloadEnabled = toolbarConfig?.downloadData?.enabled ?? false;
  const { tree } = useTreeMapRawData();

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => buildAndDownloadCsv(tree);

  const showDefaultToolbarDownloadButton =
    isDownloadEnabled && !toolbarConfig?.intents;
  const showMenuToolbarButton =
    isDownloadEnabled && !!toolbarConfig?.intents?.length;

  const initialA11yState: A11yToolbarTabIndex[] =
    showDefaultToolbarDownloadButton ? [{ download: 0 }] : [{ intent: 0 }];

  const behaviorTrackingProps = _useBehavioralTrackingProps(
    toolbarConfig ?? {},
  )[0];

  return (
    <ChartToolbarRenderer
      placement={toolbarPlacement}
      collapsed={toolbarConfig?.collapsed}
      initialA11yState={initialA11yState}
      onMouseEnter={handleMouseEnter}
      menuDisplayMode="never"
      isDownloadEnabled={showMenuToolbarButton}
      intents={toolbarConfig?.intents}
      handleDownloadDataToolbar={handleDownloadDataToolbar}
      draggable
      removeDragHandle
      visibleWhenMouseInBounds
      {...behaviorTrackingProps}
    >
      {showDefaultToolbarDownloadButton && <TreeMapDownloadDataButton />}
    </ChartToolbarRenderer>
  );
};
